import { InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, fullWidth = false, className = '', id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
    const widthStyles = fullWidth ? 'w-full' : '';

    const inputStyles = `
      block px-3 py-2 border rounded-lg shadow-sm
      bg-background text-text-primary placeholder:text-text-muted
      focus:outline-none focus:ring-2 focus:ring-offset-0
      disabled:opacity-50 disabled:cursor-not-allowed
      ${
        error
          ? 'border-error focus:ring-error focus:border-error'
          : 'border-border focus:ring-primary focus:border-primary'
      }
      ${widthStyles}
      ${className}
    `;

    return (
      <div className={widthStyles}>
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-text-primary mb-1">
            {label}
          </label>
        )}
        <input ref={ref} id={inputId} className={inputStyles} {...props} />
        {error && (
          <p className="mt-1 text-sm text-error" role="alert">
            {error}
          </p>
        )}
        {helperText && !error && <p className="mt-1 text-sm text-text-secondary">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
